module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__prices__forwarding",
      "loading": _vm.progress
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.pricesAmount,
      "link": "",
      "table-id": "forwardingprices"
    },
    on: {
      "refresh": _vm.getPrices,
      "create": _vm.addPrice
    },
    scopedSlots: _vm._u([{
      key: "city",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "no-breack-words": ""
          }
        }, [_vm._v(" " + _vm._s(scope.item.city ? scope.item.city.name : 'Не установлен'))])]
      }
    }, {
      key: "street_value",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "no-breack-words": ""
          }
        }, [_vm._v(" " + _vm._s(scope.item.street_value ? scope.item.street_value : 'Не установлена'))])]
      }
    }, {
      key: "type",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(parseInt(scope.item.type) == 2 ? 'По объёму' : 'По весу'))]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'clone'],
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.clone(scope.item.id)
            }
          }
        }), _vm._v(" "), _c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.prices),
      callback: function($$v) {
        _vm.prices = $$v
      },
      expression: "prices"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f738b7ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/ForwardingPrices.vue
// module id = 1281
// module chunks = 0